import { ITableHeader, IResultData } from './types';
import { UseTableCellProps } from 'react-table';

export function convertToTableHeaderColumns(jsonData: ITableHeader[]) {
  return jsonData.map((column) => {
    const {
      header,
      accessor,
      sortable,
      filterable = false,
      type,
      isInternal,
    } = column;
    const className = `FileDownloadExperienceSearchResultDekstop-tableCol${accessor.charAt(
      accessor.length - 1
    )}`;
    const sortingAriaLabel = sortable ? 'sort by column header' : undefined;
    const Header = header;

    const formatLinkCellfn = <T extends object>(cell: UseTableCellProps<T>) => {
      return cell.row.original[`original${accessor}`] || cell.value;
    };

    const formatCell = formatLinkCellfn;
    if (type === 'button') {
      return {
        Header,
        accessor,
        sortable,
        sortingAriaLabel,
        className,
        filterable,
        internal: isInternal,
      };
    }
    return {
      Header,
      accessor,
      sortable,
      sortingAriaLabel,
      className,
      filterable,
      formatCell,
      internal: isInternal,
    };
  });
}

export function convertTableValue(value: string) {
  let convertedValue: any = value.toLowerCase();

  const dateParts = value.split('/');
  const month = parseInt(dateParts[0]);
  const day = parseInt(dateParts[1]);
  const year = parseInt(dateParts[2]);

  if (!isNaN(month) && !isNaN(day) && !isNaN(year)) {
    return `${year.toString()}/${month.toString()}/${day.toString()}`;
  } else if (/^\d/.test(value) === true) {
    convertedValue = ' ' + value;
  }
  return convertedValue;
}

export function transformFilterData(columnData, mobileData): IResultData[] {
  const result: IResultData[] = [];
  columnData.forEach((col) => {
    if (col.filterable === true) {
      const header = col.Header;
      const accessor = col.accessor;

      const options: string[] = [];
      const newCols: { option: string; selected: boolean }[] = [];

      const sortedData = mobileData.sort((a, b) => {
        return a[accessor].localeCompare(b[accessor], 'en', {
          numeric: true,
          sensitivity: 'base',
        });
      });

      sortedData.forEach((data) => {
        data[accessor] && typeof data['original' + accessor] === 'object'
          ? options.push(data['original' + accessor].props.children)
          : options.push(data['original' + accessor] || data[accessor]);
      });

      let uniqueOptions = new Set(options);
      uniqueOptions.forEach((option) => {
        newCols.push({ option: option, selected: false }); // Set selected as boolean false
      });

      result.push({
        header: header,
        cols: newCols,
        accessor: accessor,
      });
    }
  });

  return result;
}

export function filterData(data, filters) {
  let filteredData = data;

  filters.forEach((filter) => {
    if (filter.cols) {
      const selectedOptions = filter.cols
        .filter((option) => option.selected)
        .map((option) => option.option);
      if (selectedOptions.length > 0) {
        filteredData = filteredData.filter((row) => {
          return selectedOptions.includes(
            typeof row['original' + filter.accessor] === 'object'
              ? row['original' + filter.accessor].props.children
              : row['original' + filter.accessor] || row[filter.accessor]
          );
        });
      }
    }
  });
  return { filteredData };
}
